import React from 'react';

import './style.scss';

const EmptyHelp: React.FC<any> = props => {
    return <div className="empty-help-root">{props.children}</div>;
};

export default EmptyHelp;
